// CommonJS for usage in tailwind.config.js
module.exports = {
  xxs: 352,
  sm: 992,
  md: 1568,
};
